import { render, staticRenderFns } from "./FlightDetailsBox.vue?vue&type=template&id=a8543f44&"
import script from "./FlightDetailsBox.vue?vue&type=script&lang=js&"
export * from "./FlightDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./FlightDetailsBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/agent_x64/_work/4/s/TravelportTH/Responsive GO/galileo-online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VExpansionPanel,VExpansionPanelContent,VFlex,VLayout,VSpacer})
